import React, { useState } from 'react';
import clsx from 'clsx';

import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Box from '@material-ui/core/Box';
import { alpha, makeStyles } from '@material-ui/core/styles';
import AllInclusiveIcon from '@material-ui/icons/AllInclusive';
import InfoIcon from '@material-ui/icons/Info';
import CmtList from '../../../../../@coremat/CmtList';

const useStyles = makeStyles(theme => ({
  actionsRoot: {
    transition: 'all 0.3s ease',
    transform: 'translateX(-110%)',
    opacity: 0,
    visibility: 'hidden',
    marginLeft: 10,
  },
  hoverAction: {
    '&:hover $actionsRoot': {
      transform: 'translateX(0%)',
      opacity: 1,
      visibility: 'visible',
    },
  },
  tableRowRoot: {
    position: 'relative',
    transition: 'all .2s',
    borderTop: `solid 1px ${theme.palette.borderColor.main}`,
    '&:last-child': {
      borderBottom: `solid 1px ${theme.palette.borderColor.main}`,
    },
  },
  tableCellRoot: {
    paddingLeft: 10,
    paddingRight: 10,
    textAlign: "center",
    paddingTop: 5,
    paddingBottom: 5,
    fontSize: 14,
    letterSpacing: 0.25,
    color: theme.palette.text.primary,
    borderBottom: '0 none',
    '&:first-child': {
      paddingLeft: 24,
    },
    '&:last-child': {
      paddingRight: 24,
    },
    '& .Cmt-avatar-more': {
      fontSize: 10,
      color: theme.palette.primary.main,
    },
    '& .Starter1': {
      '&::after': {
        content: '"(G)"',
        display: "inline-bock"
      },
    },
    '& .Starter2': {
      '&::after': {
        content: '"(G)"',
        display: "inline-bock"
      },
    },
    '& .Starter5': {
      '&::after': {
        content: '"(C)"',
        display: "inline-bock"
      },
    },
    '& .Starter3': {
      '&::after': {
        content: '"(F)"',
        display: "inline-bock"
      },
    },
    '& .Starter4': {
      '&::after': {
        content: '"(F)"',
        display: "inline-bock"
      },
    },
  },
  tableCellSecondaryColor: {
    color: theme.palette.text.secondary,
  },
  blockRoot: {
    display: 'block',
    fontSize: 14,
  },
  tooltip: {
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
    boxShadow: theme.shadows[1],
    fontSize: 14,
  }
}));

const TableItem = ({ row }) => {
  const classes = useStyles();


  return (
      <TableRow className={clsx(classes.hoverAction, classes.tableRowRoot)}>
        <TableCell className={classes.tableCellRoot}>
          <div className={row?.lineup_position}>{row?.first_name} {row?.last_name}&nbsp;</div>
        </TableCell>
      </TableRow>
  );
};

export default TableItem;
